<template>
    <div>
        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <div class="flex justify-between cursor-pointer" @click="show = !show">
            Href Langs
            <div>
                <svg v-if="show" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="{2}" d="M5 15l7-7 7 7" />
                </svg>
                <svg v-if="!show" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </div>
            </div>
            <div v-if="show">
                <div class="mt-6" v-for="(datum, index) in data" :key="index">
                    <div class="flex">
                        <input-text
                            :disabled="disabled"
                            name="name"
                            label="Url"
                            v-model="datum.url"
                            class="w-1/2"
                            :error="errors[`href_langs.${index}.url`] ? errors[`href_langs.${index}.url`][0] : null"
                            :maxlength=255
                        />
                        <div
                            class="border bg-white rounded-lg w-1/2 p-4 shadow-sm ml-4"
                        >
                            <div class="flex justify-between">
                                <p class="text-gray-700">Language</p>
                                <reference
                                    create-text="Create new language and link language to this page"
                                    link-text="Link an existing language"
                                    :disabled="disabled"
                                    v-model="datum.site_language"
                                    model-data="Site Language"
                                    :creatable="false"
                                    :inline="true"
                                    @input="obj => updateLanguage(index)"
                                    :error="errors[`href_langs.${index}.site_language_id`] ? errors[`href_langs.${index}.site_language_id`][0] : null"
                                    :order="{
                                        'name': 'asc'
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-if="data.length > 1" @click="deleteHrefLang(index)" class="text-xs mt-1 cursor-pointer text-right">
                        Delete
                    </div>
                </div>
                <div v-if="variants.length > 0">
                    <p  class="mt-4">Automatic HrefLangs</p>
                    <div  class="mt-2" v-for="(variant, index) in variants" :key="`pre-drefined-${index}`">
                        <div class="flex">
                            <input-text
                                :disabled="true"
                                name="name"
                                label="Url"
                                v-model="variant.url"
                                class="w-1/2"
                                :error="errors[`href_langs.${index}.url`] ? errors[`href_langs.${index}.url`][0] : null"
                            />
                            <div
                                class="border bg-white rounded-lg w-1/2 p-4 shadow-sm ml-4"
                            >
                                <div class="flex justify-between">
                                    <p class="text-gray-700">Language</p>
                                    <reference
                                        create-text="Create new language and link language to this page"
                                        link-text="Link an existing language"
                                        :disabled="true"
                                        v-model="variant.site_language"
                                        model-data="Site Language"
                                        :creatable="false"
                                        :inline="true"
                                        @input="obj => updateLanguage(index)"
                                        :error="errors[`href_langs.${index}.site_language_id`] ? errors[`href_langs.${index}.site_language_id`][0] : null"
                                        :order="{
                                            'name': 'asc'
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="addHrefLang" class="mt-6 cursor-pointer">
                    + Add Href Lang
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HrefLang",
    props: {
        value: Array,
        errors: {
            type: [Object, Array],
            required: false,
        },
        disabled:{
            type: Boolean,
            default: false
        },
        variants: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            data: this.value ? this.value : [{url: "", site_language_id: null, site_language: null}],
            show: false,
        };
    },
    watch: {
        "value.site_language": function(index){
            this.form.meta_id = newValue.id || null;
        }
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        addHrefLang: function(){
            this.data.push({
                url: "",
                site_language_id: null,
                site_language: null,
            });
        },
        deleteHrefLang: function(index){
            const canDelete = confirm('Are you sure you want to delete this Href Lang?');
            if(canDelete){
                this.data.splice(index, 1)
            }
        },
        updateLanguage: function(index){
            this.value[index].site_language_id = this.value[index]?.site_language?.id || null;
        }
    }
}
</script>
